/**
 * @fileoverview Decide se um dropdown aberto a partir de um campo dentro de um
 * Dialog do MUI cabe ao LADO DIREITO do dialog, e devolve o offset horizontal
 * (em px, a partir da borda esquerda do campo) para ancorá-lo lá.
 *
 * Usado pelos filtros do modal de Filtros de /tickets (FilterPopover, Select de
 * conexão e Autocomplete de usuários). Devolve `null` quando não cabe — o
 * chamador então abre abaixo do campo, como no mobile. Assim o painel nunca
 * sai da viewport nem cobre o modal: quem posiciona (MUI Popover/popper.js)
 * recebe um offset numérico, e não uma margem CSS aplicada depois do clamp.
 */

export const DIALOG_SIDE_GAP = 12;
const VIEWPORT_MARGIN = 16;

/**
 * @param {HTMLElement} el      campo que abre o dropdown
 * @param {number} panelWidth   largura do painel que vai abrir
 * @returns {number|null}       offset horizontal para anchorOrigin/offset, ou null
 */
export function measureDialogSide(el, panelWidth) {
  if (!el || typeof el.getBoundingClientRect !== "function") return null;
  const dialog = el.closest ? el.closest(".MuiDialog-paper") : null;
  const elRect = el.getBoundingClientRect();
  const edgeRight = dialog ? dialog.getBoundingClientRect().right : elRect.right;
  const fits = window.innerWidth - edgeRight - DIALOG_SIDE_GAP - panelWidth >= VIEWPORT_MARGIN;
  if (!fits) return null;
  return Math.round(elRect.width + (edgeRight - elRect.right) + DIALOG_SIDE_GAP);
}
